import { useMutation } from '@tanstack/react-query';

import { createRequestCustomer } from '../services';

export function useCreateRequestCustomer() {
  return useMutation({
    mutationFn: createRequestCustomer,
  });
}
